import './Pricing.scss';
import Component from './Pricing.js';
export default Component;
